import styled from 'styled-components';

const H2 = styled.h2`
  color: ${(props) => props.color || 'var(--content-title)'};
  font-family: var(--font-family-title);
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0;
  margin: 0;
`;

export { H2 };
